
import Team from "@/shared/teams/team";
import ComparedTeam from "@/shared/teams/team";
import { ref, watch } from "vue";
import { useStore } from "vuex";
import Matchup from "@/shared/matchups/matchup";

function useComparer() {
  const store = useStore();
  type WeeklyRecord = {
    [index: number]: any;
    wins: number;
    losses: number;
    ties: number;
  };
  type ScoreCounter = {
    [index: number]: any;
    id: number;
    name: string;
    wins: number;
    losses: number;
    ties: number;
    weeklyRecords: WeeklyRecord;
  };
  const teams = ref<Team[]>([]);
  const teamScheduleLookup = ref<ScoreCounter>({} as ScoreCounter);
  const teamAggregateScore = ref<ScoreCounter>({} as ScoreCounter);

  const getRecordColumnClass = function (team: Team, teamToCompareTo: Team) {
    if (team && teamToCompareTo && team.id === teamToCompareTo.id)
      return "row--striped";
    return "";
  };

  const getRecord = function (teamToUse: Team, teamToCompareAgainst: Team) {
    const season = store.state.league[store.state.league.length - 1];
    let scores = season.schedule.map((matchup: Matchup) => {
      if (matchup.playoffTierType !== 'NONE') return;
      
      if (matchup.away.teamId === teamToUse.id) return matchup.away.totalPoints;

      if (matchup.home.teamId === teamToUse.id) return matchup.home.totalPoints;

      return 0;
    });

    let scoresAgainst = season.schedule.map((matchup: Matchup) => {
      if (matchup.playoffTierType !== 'NONE') return;

      if (matchup.away.teamId === teamToCompareAgainst.id) {
        if (matchup.home.teamId === teamToUse.id)
          return matchup.away.totalPoints;

        return matchup.home.totalPoints;
      }

      if (matchup.home.teamId === teamToCompareAgainst.id) {
        if (matchup.away.teamId === teamToUse.id)
          return matchup.home.totalPoints;

        return matchup.away.totalPoints;
      }

      return 0;
    });

    scores = scores.filter((x: number) => x > 0);
    scoresAgainst = scoresAgainst.filter((x: number) => x > 0);
    let wins = 0;
    let losses = 0;
    let ties = 0;
    for (let i = 0; i < scores.length; i++) {
      if (scores[i] < scoresAgainst[i]) {
        losses++;
      } else if (scores[i] > scoresAgainst[i]) {
        wins++;
      } else if (scores[i] && scoresAgainst[i]) {
        ties++;
      }
    }

    if (ties === 0) return wins + "-" + losses;

    return wins + "-" + losses + "-" + ties;
  };

  function compareSchedules() {
    const season = store.state.league[store.state.league.length - 1];
    teams.value = [];
    if (!season) return;
    for (let i = 0; i < season.teams.length; i++) {
      teams.value.push(season.teams[i]);
      teamAggregateScore.value[season.teams[i].id] = {
        Wins: 0,
        Losses: 0,
        Ties: 0,
      };
    }

    for (let i = 0; i < teams.value.length; i++) {
      const teamToUse = teams.value[i] as ComparedTeam;

      const scores = season.schedule.map((matchup: Matchup) => {
        if (matchup.playoffTierType !== 'NONE') return;

        if (matchup.away.teamId === teamToUse.id)
          return matchup.away.totalPoints;

        if (matchup.home.teamId === teamToUse.id)
          return matchup.home.totalPoints;
      });

      teamToUse.weeklyRecord = [];
      teamScheduleLookup.value[teamToUse.id] = scores;
    }

    for (let teamIndex = 0; teamIndex < teams.value.length; teamIndex++) {
      for (let weekIndex = 0; weekIndex < season.schedule.length; weekIndex++) {
        const team = teams.value[teamIndex] as ComparedTeam;
        const matchup = season.schedule[weekIndex];

        let wins = 0;
        let losses = 0;
        let ties = 0;

        const scoreToCompareAgainst =
          teamScheduleLookup.value[team.id][matchup.matchupPeriodId];

        for (let i = 0; i < teams.value.length; i++) {
          if (teams.value[i] == team) continue;

          const opponentScore =
            teamScheduleLookup.value[teams.value[i].id][matchup.matchupPeriodId];

          if (scoreToCompareAgainst < opponentScore) {
            losses++;
          } else if (scoreToCompareAgainst > opponentScore) {
            wins++;
          } else {
            ties++;
          }
        }

        teamAggregateScore.value[team.id].name =
          team.location + " " + team.nickname;
        teamAggregateScore.value[team.id].id = team.id;
        teamAggregateScore.value[team.id].wins += wins;
        teamAggregateScore.value[team.id].losses += losses;
        teamAggregateScore.value[team.id].ties += ties;

        // if (ties === 0) {
        //   team.weeklyRecord[matchup.matchupPeriodId] = wins + "-" + losses;
        // } else {
        //   team.weeklyRecord[matchup.matchupPeriodId] = wins + "-" + losses + "-" + ties;
        // }
      }
    }
  }

  watch(
    () => store.state.leagueId,
    () => {
      compareSchedules();
    }
  );

  watch(
    () => store.state.league,
    () => {
      compareSchedules();
    }
  );

  compareSchedules();

  return {
    getRecord,
    getRecordColumnClass,
    teamAggregateScore,
    teams,
  };
}

export default {
  setup() {
    return useComparer();
  },
};
